module.exports = __webpack_public_path__ + "static/img/logoword.8bf4f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoword.png
// module id = fQTa
// module chunks = 17